import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
export default function CancellationandRefund() {
  return (
   <>
    <div className="py-5" style={{ backgroundColor: "#f8f9fa", marginTop:"6rem", minHeight: "100vh" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <div className="bg-white p-4 p-md-5 rounded shadow">
              <h1 className="mb-4 text-center">Terms & Conditions – V Hotel The Grand Shoba</h1>

              <h5>1. Introduction</h5>
              <p>
                Welcome to V Hotel The Grand Shoba. By accessing and using our website to make a reservation or payment, you agree to be bound by the following terms and conditions. Please read them carefully.
              </p>

              <h5 className="mt-4">2. Booking & Payments</h5>
              <ul>
                <li>All bookings are subject to availability and confirmation.</li>
                <li>We use <strong>Razorpay</strong> as our secure payment gateway for online transactions.</li>
                <li>By proceeding with an online booking, you authorize us and Razorpay to process the payment on your behalf.</li>
                <li>Payments can be made using debit/credit cards, UPI, net banking, and other Razorpay-supported methods.</li>
              </ul>

              <h5 className="mt-4">3. Payment Confirmation</h5>
              <ul>
                <li>Once the payment is successfully processed, you will receive a confirmation email/SMS with your booking details.</li>
                <li>If you do not receive confirmation within 24 hours, please contact our support team:</li>
                <li>
                  📧 Email: <a href="mailto:info@vhotelthegrandshoba.com">info@vhotelthegrandshoba.com</a><br />
                  📞 Phone: <a href="tel:+919811320209">+91 9811320209</a>, <a href="tel:+919811226576">+91 9811226576</a>
                </li>
              </ul>

              <h5 className="mt-4">4. Pricing & Taxes</h5>
              <ul>
                <li>All room rates are inclusive of applicable taxes unless stated otherwise.</li>
                <li>We reserve the right to modify our pricing at any time without prior notice, but confirmed bookings will not be affected.</li>
              </ul>

              <h5 className="mt-4">5. Cancellation & Refund Policy</h5>
              <ul>
                <li>Cancellations made <strong>24 hours or more</strong> before the check-in date are eligible for a full refund.</li>
                <li>Cancellations made <strong>less than 24 hours</strong> before check-in will be subject to one night's charge as a cancellation fee.</li>
                <li>No-show guests will be charged 100% of the booking amount.</li>
                <li>Refunds (if applicable) will be processed through the original payment method within 7–10 business days.</li>
              </ul>

              <h5 className="mt-4">6. Payment Gateway – Razorpay</h5>
              <ul>
                <li>Razorpay is a third-party payment processor. By using Razorpay, you agree to their terms and privacy policy.</li>
                <li>We are not responsible for any technical issues or delays caused by the payment gateway.</li>
              </ul>

              <h5 className="mt-4">7. Data Security</h5>
              <ul>
                <li>All payment transactions are encrypted and processed securely.</li>
                <li>We do not store your credit/debit card details on our servers.</li>
                <li>Your personal data is protected as per our <strong>Privacy Policy</strong>.</li>
              </ul>

              <h5 className="mt-4">8. Liability</h5>
              <ul>
                <li>V Hotel The Grand Shoba is not liable for any loss or damage arising directly or indirectly from payment failures or technical issues with Razorpay.</li>
                <li>In case of double payment or excess deduction, please contact us for resolution.</li>
              </ul>

              <h5 className="mt-4">9. Contact Information</h5>
              <p>
                For queries related to bookings, payments, or cancellations, contact us:<br />
                📧 Email: <a href="mailto:info@vhotelthegrandshoba.com">info@vhotelthegrandshoba.com</a><br />
                📞 Phone: <a href="tel:+919811320209">+91 9811320209</a>, <a href="tel:+919811226576">+91 9811226576</a>
              </p>

              <h5 className="mt-4">10. Changes to T&amp;Cs</h5>
              <p>
                We reserve the right to update or modify these terms and conditions at any time without prior notice. Please review them periodically.
              </p>
                  <p className="mt-4 text-muted text-center">
                Last updated: May 2025
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
   
   </>
  )
}
